import { Tv } from 'lucide-react';

/**
 * Loaded inside the Fire TV app's WebView once a token is already saved.
 * Fire TV has no browsing UI of its own by design (unlike the Roku channel)
 * -- QudeDetectionService reads MediaSession metadata from whatever
 * streaming app is in the foreground and reports it directly, and the TV
 * only needs to be a launch *target* (see /api/qude-protocol/launch +
 * pending-launch), not something you navigate around with a remote. This
 * screen is just a quiet confirmation that detection is running.
 */
export default function FireTVStatus() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#050508', flexDirection: 'column', gap: 16, padding: 24, textAlign: 'center',
    }}>
      <Tv size={40} style={{ color: '#4A9EFF' }} />
      <p style={{ color: '#fff', fontSize: 20, fontWeight: 700 }}>Qude is running on this Fire TV</p>
      <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, maxWidth: 420 }}>
        It's detecting what you watch automatically. Browse your Hub and launch shows from your phone or qudetv.com — this screen doesn't need to stay open.
      </p>
    </div>
  );
}
